<template>
  <!-- BITCOIN FAQ -->
  <v-container
    fluid
    class="mt-12 mb-12"
    :style="'overflow-y: scroll; max-height: 100%;'"
  >
    <v-card dark>
      <v-row class="d-flex justify-center pr-1 pl-1"> 
        <v-col cols="12" class="mx-auto text-center mt-3">
          <h2 class="text-center text-h4 font-weight-bolder">
            Zamówienie do <span :style="'color: cyan;'">1000zł</span>
          </h2>
        </v-col>
        <v-col cols="12" lg="8" md="8" class="text-left">
          Ta metoda jest najszybsza, najprostsza i w pełni bezpieczna. Możesz zapłacić za zamówienie za pomocą BLIKa, mBank, ING itd. Jeżeli twoje zamówienie
          przekracza 1000zł użyj innej metody opisanej poniżej!
        </v-col>
        <v-col
            cols="12"
            class="d-flex justify-center text-center pt-0 pb-0 mt-2 mb-2"
          >
            <v-btn large @click="tutorialDialog = true" light>
              <v-icon>fab fa-youtube</v-icon>&nbsp;
              <strong>Zobacz wideo</strong>
            </v-btn>
          </v-col>
        <v-col cols="12" lg="8" md="8" class="text-left">
          <span :style="'color: cyan;'">1)</span> Wejdź na stronę
          <a href="https://cryps.pl/kup-bitcoin-kantor-btc-pln/#ari-widget" target="_blank">cryps.pl/kup-bitcoin-kantor-btc-pln/</a
          ><br /><br />
          <span :style="'color: cyan;'">2)</span> Podaj kwotę w zł - taką samą jak kwota zamówienia<br /><br />
          <span :style="'color: cyan;'">3)</span> Kliknij przycisk "Kupuję BTC"<br /><br />
          <span :style="'color: cyan;'">4)</span> W miejscu adresu wpisz "Adres bitcoin do wpłaty" który znajdziesz na stronie płatności i
          kliknij "Potwierdź"<br /><br />
          <span :style="'color: cyan;'">5)</span> Następnie podaj adres email i kliknij "Potwierdź" (nie musi być
          prawdziwy)<br /><br />
          <span :style="'color: cyan;'">6)</span> Następnie podaj numer telefonu, kliknij "Nie jestem robotem" i
          kliknij "Potwierdź"<br /><br />
          <span :style="'color: cyan;'">7)</span> Wpisz kod otrzymany przez SMS  i kliknij "Potwierdź" <br /><br />
          <span :style="'color: cyan;'">8)</span> Na etapie "Typ przelewu" nic nie musisz zmieniać i kliknij "Potwierdź" <br /><br />
          <span :style="'color: cyan;'">9)</span> Wybierz formę płatności i kliknij "Potwierdź" <br /><br />
          <span :style="'color: cyan;'">10)</span> Opłać zamówienie na stronie do której zostaniesz przeniesiony <br /><br />
          <span :style="'color: cyan;'">11)</span> Po opłaceniu zamówienia twoja płatność na naszej stronie przejdzie do realizacji w niedłużej niż 10 min. <br />
        </v-col>
      </v-row>
      <v-divider class="mt-3 mb-3" size="2"></v-divider>
      <v-row class="d-flex justify-center  pr-1 pl-1"> 
        <v-col cols="12" class="mx-auto text-center mt-3">
          <h2 class="text-center text-h4 font-weight-bolder">
            Zamówienie do <span :style="'color: cyan;'">4500zł***</span>
          </h2>
        </v-col>
        <v-col cols="12" lg="8" md="8" class="text-left">
          Ta metoda korzysta z rozpowszechnionych Bitomatów! Mapę dostępnych bitomatów znajdziesz <a href="https://wymianakrypto.pl/bitomaty#element_703" target="_blank">tutaj</a><br>
          <span :style="'color: cyan;'">***Jeżeli twoje zamówienie przekracza 4500zł możesz wykonać poniższe kroki kilika razy aby w pełni opłacić zamówienie. Poniżej podajemy przykład:</span><br>
          Załóżmy że twoje zamówienie wynosi 7000zł. Wykonaj poniższe kroki na kwotę 4500zł następnie powtórz poniższe kroki na kwotę 2500zł. Nasz system zaakceptuje twoje płatności!

        </v-col>
        <v-col cols="12" lg="8" md="8" class="text-left">
          <span :style="'color: cyan;'">1)</span> Znajdź najbliższy bitomat na mapie <a href="https://wymianakrypto.pl/bitomaty#element_703" target="_blank">tutaj</a><br /><br />
          <span :style="'color: cyan;'">2)</span> Na ekranie bitomatu kliknij "Kupuje Bitcoin/BTC"<br /><br />
          <span :style="'color: cyan;'">3)</span> Zeskanuj kod QR ze strony płatności<br /><br />
          <span :style="'color: cyan;'">4)</span> Wprowadź do bitomatu banknoty w kwocie odpowiadającej kwocie zamówienia. <span :style="'color: cyan;'">Ważne!</span> Jeżeli nie masz zamiaru robić kilku wpłat bitomatem, pamiętaj aby wpłacona kwota nie była mniejsza niż kwota zamówienia! Zwróć uwagę jakie banknoty przyjmuje twój bitomat!<br /><br />
          <span :style="'color: cyan;'">5)</span> Kliknij "Wyślij bitcoiny" lub "send coins"<br /><br />
          <span :style="'color: cyan;'">6)</span> Jeżeli bitomat pyta cię o opłatę transakcyjną (np. suwak), nic nie zmieniaj i potwierdź komunikat. <br /><br />
          <span :style="'color: cyan;'">7)</span> Po wysłaniu bitcoinów przez bitomat twoja płatność na naszej stronie przejdzie do realizacji w przeciągu 10-30 min.<br /><br />
        </v-col>
      </v-row>
      <v-divider class="mt-3 mb-3" size="2"></v-divider>
      <v-row class="d-flex justify-center  pr-1 pl-1"> 
        <v-col cols="12" class="mx-auto text-center mt-3">
          <h2 class="text-center text-h4 font-weight-bolder">
            Dla zaawansowanych użytkowników
          </h2>
        </v-col>
        <v-col cols="12" lg="8" md="8" class="text-left">
          Przyjmujemy przelewy z giełd takich jak np. Binance.
          Przyjmujemy również bezpośrednie przelewy z portfeli takich jak Electrum, Ledger, Trezor lub innych.
          Płatności wymagają 1 potwierdzenia na sieci. Pamiętaj aby przelewy wykonywać tylko przez sieć BTC.
          Płatności z sieci testowych nie będą księgowane!
        </v-col>
        
      </v-row>
    </v-card>
    <v-dialog
      v-model="tutorialDialog"
      :fullscreen="$vuetify.breakpoint.mobile"
      hide-overlay
      dark
      width="800"
      :transition="
        this.$vuetify.breakpoint.mobile
          ? 'slide-x-transition'
          : 'dialog-bottom-transition'
      "
    >
      <v-card>
        <v-toolbar>
          <v-btn icon @click="!(tutorialDialog = false) && ($refs.video.pause())">
            <v-icon :style="'color: white;'">{{
              this.$vuetify.breakpoint.mobile
                ? "fas fa-chevron-left"
                : "fas fa-times"
            }}</v-icon>
          </v-btn>
          <v-toolbar-title :style="'color: white;'"
            >Jak zapłacić?
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-container fluid class="p-1">
          <v-row class="d-flex justify-center">
            <v-col cols="12" class="d-flex justify-center">
              <div class="video-player">
                <video
                id="tutorialVideoElement"
                  class="video"
                  ref="video"
                  :style="'width:100%; height:auto;'"
                  controls
                >
                  <source
                    src="../assets/tutorial_payment.mp4"
                    type="video/mp4"
                  />
                </video>
              </div>
            </v-col>
            <v-col cols="12" class="mt-3">
              <v-row>
                <v-col
                  cols="12"
                  class="d-flex justify-center text-center pt-0 pb-0 mt-2 mb-2"
                >
                  <v-btn large light>
                    <a
                      href="https://cryps.pl/kup-bitcoin-kantor-btc-pln/#ari-widget"
                      target="_blank"
                      :style="'color: #1481D1 !important;'"
                      ><strong>Do strony cryps.pl</strong>&nbsp;<v-icon
                        >fas fa-arrow-circle-right</v-icon
                      ></a
                    >
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
  
</template>

<script>
export default {
  name: "BitcoinFaqView",
  data: () => ({
    tutorialDialog:false
  }),
  components: {},
};
</script>

<style>
.bg-transparent {
  background-color: transparent !important;
}
</style>
